var React   = require("react");

var ActionAlert = require("patternity/lib/alert/action_alert");
var { withNamespaces } = require('react-i18next');

var ChallengeError = React.createClass({
  PropTypes : {
    errors : React.PropTypes.string.isRequired,
    fetchChallenges : React.PropTypes.func.isRequired,
    fetchAction : React.PropTypes.string.isRequired
  },

  getDefaultProps : function(){
    return {
      errors : null,
      fetchChallenges : function(){},
      fetchAction : ""
    }
  },

  render : function(){
    const error = this._hasErrors();

    return (
      <div className="challenges-error">
        {error && (
          <ActionAlert title={this.props.t('Error Loading Challenges!')} action={this._alertAction()} showIcon={true} type="error" showAlert={this._hasErrors()}>
            <p>{this.props.t('We were unable to load challenges at this time.')}</p>
          </ActionAlert>
        )}
      </div>
    );
  },

  _hasErrors : function(){
    if(this.props.errors === null){
      return false;
    }

    return true;
  },

  _alertAction : function(){
    return {
      title : this.props.t('Try Again'),
      onClick : this._handleClick
    };
  },

  _handleClick : function(event){
    this.props.fetchChallenges(this.props.fetchAction);
  }
});

module.exports = withNamespaces()(ChallengeError);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_error.jsx